<template>
  <div>
    <vx-card class="mt-base mb-5">
      <heading size="h2" style-size="h4" class="mb-5">{{ activityTitle }}</heading>
      <p class="mb-5">
        The ISBAR Framework is used in all communications in handovers and incidents.
      </p>

      <div class="vx-row mt-10">
        <div class="vx-col lg:w-1/2 md:w-1/2 w-full mb-base">
          <heading size="h3" style-size="h5" class="text-underline mb-5">Your Task:</heading>
          <ul class="default-list">
            <li>Watch videos 1 and 2 on the right</li>
            <li>Answer the questions below</li>
          </ul>

          <p class="mb-5">
            1. In the video "ISBAR Framework - Telephone Handover", what information belongs in each
            of the fields: Introduction; Situation; Background; Assessment; Recommendation? Select
            your answers below.
          </p>

          <div v-for="(question, index) in list1" :key="'isbar_select_' + index">
            <label>
              <i>{{ question.name }}</i>
              <div class="vx-row mb-3">
                <div
                  class="vx-col w-full mbx-2"
                  v-if="isEditable"
                  :class="{
                    wrong: question.answer > 0 && question.correct != question.answer,
                  }"
                >
                  <select
                    class="default-select"
                    v-model="question.answer"
                    :name="'isbar_select_' + index"
                  >
                    <option
                      v-for="answer in isbar_labels"
                      :key="answer.val + '-' + index"
                      :value="answer.val"
                    >
                      {{ answer.name }}
                    </option>
                  </select>
                  <span
                    v-if="question.answer > 0 && question.correct != question.answer"
                    class="visually-hidden"
                    aria-live="assertive"
                  >
                    Wrong answer
                  </span>
                  <span
                    v-if="question.correct == question.answer"
                    class="visually-hidden"
                    aria-live="assertive"
                  >
                    Correct answer
                  </span>
                </div>
                <div class="my-2 mx-5" v-else>
                  <div v-if="question.answer != 0 && question.answer != null">
                    <p class="my-2" v-for="answer in isbar_labels" :key="answer.val">
                      <span v-if="question.answer == answer.val">{{ answer.name }}</span>
                    </p>
                  </div>
                  <p class="my-2" v-else>N/A</p>
                </div>
              </div>
            </label>
          </div>

          <p class="mb-5">
            2. In the video "The ISBAR Framework - Clinical Handover", if the nurse doing the
            handover to the new nurse (Jo) had not mentioned in the recommendation that the patient
            Regina should have some physiotherapy and a repeat x-ray, what could have gone wrong?
          </p>
          <div v-for="(question, index) in questions" :key="'2_' + index">
            <label>
              <heading size="h3" style-size="h5" class="mb-5 questionlabel">
                {{ index }}. {{ question.question }}
              </heading>
              <div class="vx-row my-5">
                <div
                  class="vx-col w-full mb-2"
                  v-if="isEditable"
                  :class="{
                    wrong:
                      answers['question' + (5 + index)] > 0 &&
                      question.correct != answers['question' + (5 + index)],
                  }"
                >
                  <select
                    class="default-select"
                    v-model="answers['question' + (5 + index)]"
                    :name="'question_' + (5 + index)"
                  >
                    <option
                      v-for="answer in question.answers"
                      :key="answer.val"
                      :value="answer.val"
                    >
                      {{ answer.answer }}
                    </option>
                  </select>
                </div>
                <div class="my-2 mx-5" v-else>
                  <div
                    v-if="
                      answers['question' + (5 + index)] != 0 &&
                      answers['question' + (5 + index)] != null
                    "
                  >
                    <p class="my-2" v-for="answer in question.answers" :key="answer.val">
                      <span v-if="answers['question' + (5 + index)] == answer.val">{{
                        answer.answer
                      }}</span>
                    </p>
                  </div>
                  <p class="my-2" v-else>N/A</p>
                </div>
              </div>
            </label>
          </div>
          <save-buttons :is-editable="isEditable" @save="save" />
        </div>
        <div class="vx-col lg:w-1/2 md:w-1/2 w-full mb-base pl-10">
          <heading size="h3" style-size="h5" class="text-underline mb-5">Videos:</heading>
          <label v-for="(video, index) in videoTriggers" :key="`video-${video.title}`">
            <p class="mb-5">{{ index + 1 }}. The ISBAR Framework - {{ video.title }}</p>
            <video-trigger
              :button_id="`handover-video-${index + 1}`"
              :imageSrc="video.image"
              @click="showVideoPopup(video.video, `handover-video-${index + 1}`)"
              class="mb-5"
            ></video-trigger>
          </label>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
//import methods from "@/views/WorkExperiences/components/activity_js/methods";
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      login_type: localStorage.getItem('login_type'),
      videoTriggers: [
        {
          title: 'Telephone Handover',
          image: require('@/assets/images/experiences/nurse/isbar_telephone.jpg'),
          video:
            $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL +
            '/content/nurse/isbar_telephone_handover.m4v',
        },
        {
          title: 'Clinical Handover',
          image: require('@/assets/images/experiences/nurse/isbar_clinical.jpg'),
          video:
            $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL +
            '/content/nurse/isbar_clinical_handover.m4v',
        },
        {
          title: 'ED Handover',
          image: require('@/assets/images/experiences/nurse/isbar_ed.jpg'),
          video:
            $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL +
            '/content/nurse/isbar_ed_handover.m4v',
        },
        {
          title: 'Deteriorating Patient',
          image: require('@/assets/images/experiences/nurse/isbar_deteriorating_patient.jpg'),
          video:
            $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL +
            '/content/nurse/isbar_deteriorating_patient.m4v',
        },
      ],
      videoTriggerImg4: require('@/assets/images/experiences/nurse/isbar_deteriorating_patient.jpg'),
      isbar_labels: [
        { name: 'Introduction', val: 1 },
        { name: 'Situation', val: 2 },
        { name: 'Background', val: 3 },
        { name: 'Assessment', val: 4 },
        { name: 'Recommendation', val: 5 },
      ],
      list1: [
        { name: `Her name, role and location.`, correct: 1, answer: undefined },
        { name: `That she wanted to do a handover.`, correct: 1, answer: undefined },
        { name: `The patients name and age.`, correct: 1, answer: undefined },
        {
          name: `Presented to emergency with shortness of breath and sputum production`,
          correct: 2,
          answer: undefined,
        },
        {
          name: `Suspected exacerbation of a COPD with an infective cause.`,
          correct: 2,
          answer: undefined,
        },
        { name: `Hypotension`, correct: 3, answer: undefined },
        { name: `COPD`, correct: 3, answer: undefined },
        { name: `Heavy Smoker`, correct: 3, answer: undefined },
        { name: `Allergic to penicillin`, correct: 3, answer: undefined },
        { name: `Lives alone and fairly independent`, correct: 3, answer: undefined },
        {
          name: `Last set of OBS info (respiratory, saturations, blood pressure, heart rate, ECG, temperature, GCS)`,
          correct: 4,
          answer: undefined,
        },
        { name: `Criteria for a respiratory rate greater than 28`, answer: 4, answer: undefined },
        {
          name: `Had ECG and Chest X ray and results were….; Has cannula in; Had bloods done and white cell count was ….`,
          correct: 4,
          answer: undefined,
        },
        {
          name: `Admitted under respiratory and who the consultant/doctor is.`,
          correct: 4,
          answer: undefined,
        },
        { name: `Continue IV antibiotics and nebulisers`, correct: 5, answer: undefined },
        { name: `Have some physio`, correct: 5, answer: undefined },
      ],
      answers: {
        question1: [],
        question2: [],
        question3: [],
        question4: [],
        question5: [],
        question6: undefined,
        question7: undefined,
        question8: undefined,
        question9: undefined,
        question10: undefined,
      },
      correct_answers: {
        question1: true,
        question2: true,
        question3: true,
        question4: true,
        question5: true,
        question6: true,
        question7: true,
        question8: true,
        question9: true,
        question10: true,
      },
      questions: {
        1: {
          question: 'The patient’s recovery may have been slower',
          answers: [
            { val: undefined, answer: 'Please Select' },
            { val: 1, answer: 'Yes' },
            { val: 2, answer: 'No' },
          ],
          correct: 1,
        },
        2: {
          question: 'The patient’s health may have been put at risk',
          answers: [
            { val: undefined, answer: 'Please Select' },
            { val: 1, answer: 'Yes' },
            { val: 2, answer: 'No' },
          ],
          correct: 1,
        },
        3: {
          question:
            'The physiotherapist and radiologist could sue the nurse or hospital for providing less referrals.',
          answers: [
            { val: undefined, answer: 'Please Select' },
            { val: 1, answer: 'Yes' },
            { val: 2, answer: 'No' },
          ],
          correct: 2,
        },
        4: {
          question:
            'The patient may have had to stay in hospital longer or return to hospital with a relapse',
          answers: [
            { val: undefined, answer: 'Please Select' },
            { val: 1, answer: 'Yes' },
            { val: 2, answer: 'No' },
          ],
          correct: 1,
        },
        5: {
          question:
            ' Nothing, the patient would have been better off because she could go home sooner.',
          answers: [
            { val: undefined, answer: 'Please Select' },
            { val: 1, answer: 'Yes' },
            { val: 2, answer: 'No' },
          ],
          correct: 2,
        },
      },
    };
  },
  methods: {
    save() {
      this.data = this.answers;
      this.saveActivity(this.$route.params.slug, this.data, -1);
    },
    removeOldSelection(index) {
      const item = this.isbar_labels[index];
      if (this.answers['question' + index].length > item.num_elems) {
        let lastElem =
          this.answers['question' + index][this.answers['question' + index].length - 1];
        for (let i = this.answers['question' + index].length - 2; i < item.num_elems; i++) {
          this.list1.push(this.answers['question' + index][i]);
          this.answers['question' + index][i] = lastElem;
          this.answers['question' + index].splice(i + 1);
        }
        //this.answers['question' + index] = [];
        //this.answers['question' + index].push(lastElem);
      }
      this.checkAnswers();
    },
    checkAnswers() {
      for (let i = 1; i <= 5; i++) {
        if (
          typeof this.answers['question' + i] !== 'undefined' &&
          this.answers['question' + i].length
        ) {
          const item = this.isbar_labels[i];
          let is_correct = true;
          this.answers['question' + i].forEach((element) => {
            if (item.correct_answers.indexOf(element.id) == -1) {
              is_correct = false;
            }
          });
          if (!is_correct) {
            this.correct_answers['question' + i] = false;
          } else {
            this.correct_answers['question' + i] = true;
          }
        }
      }
    },
    resetAnswers() {
      for (let index = 1; index <= 5; index++) {
        if (this.answers['question' + index].length > 0) {
          this.answers['question' + index].forEach((element) => {
            this.list1.push(element);
          });
          this.answers['question' + index] = [];
          this.correct_answers['question' + index] = true;
        }
      }
      this.list1 = this.list1.sort(() => 0.5 - Math.random());
    },
  },
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.data !== 'undefined' && typeof this.data.question1 !== 'undefined') {
      this.answers = this.data;

      for (let i = 1; i <= 5; i++) {
        if (
          typeof this.answers['question' + i] !== 'undefined' &&
          this.answers['question' + i].length > 0
        ) {
          let id = this.answers['question' + i][0].id;
          this.list1 = this.list1.filter(function (item) {
            return item.id !== id;
          });
        }
      }
      this.checkAnswers();
    }
    //Shuffle the answers array
    this.list1 = this.list1.sort(() => 0.5 - Math.random());
    this.checkAnswers();
  },
};
</script>

<style scoped>
label.isbar_label span {
  color: #d40000;
  font-weight: bold;
}

.wrong {
  background: rgba(202, 20, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
  padding-top: 2px;
  margin: 0;
}
.defaultclass {
  margin: 0;
}
.list-group {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group.draggable-area {
  border: 1px dashed #ccc;
  min-height: 45px;
}
</style>
